module.exports = __webpack_public_path__ + "img/1540896195.fb2fea70.jpg";